<style lang="scss" scoped>
.banner {
	margin-bottom: 60px;
	cursor: pointer;
	&.small {
		width: 292px;
	}
	&.medium {
		width: 600px;
	}
	&.large {
		width: 100%;
	}
}
.img {
	height: 175px;
	background-size: 100%;
	background-repeat: no-repeat;
	background-size: contain;
	&.small {
		background-image: url("/static/img/fsm/banner-small-width-2.png");
	}
	&.medium {
		height: 175px;
		background-image: url("/static/img/fsm/banner-medium-width-2.png");
	}
	&.large {
		background-image: url("/static/img/fsm/banner-large-width-2.png");
	}
}
</style>

<template lang="pug">
	.banner(v-if="!$apollo.loading", @click="$router.push({ name: 'promotions.freeSchoolMeals' })", :class="size")
		.img(:class="size")
</template>

<script>
export default {
	props: {
		size: {
			type: String,
			default: "medium",
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/promotions/freeSchoolMeals/HomepageBanner.vue